import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  top: 12px;
  right: 12px;
  height: 2.6em;
  display: flex;
  align-items: center;
  gap: 1.2em;
  padding: 0 1em;
  font-size: 1em;
  background: ${({ theme }) =>
    theme.body === "#fafbfc"
      ? "linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(250, 251, 252, 0.98) 100%)"
      : "linear-gradient(135deg, rgba(18, 20, 26, 0.88) 0%, rgba(13, 15, 20, 0.92) 100%)"};
  backdrop-filter: blur(16px);
  border-radius: 12px;
  border: 1px solid
    ${({ theme }) =>
      theme.body === "#fafbfc"
        ? "rgba(0, 0, 0, 0.06)"
        : "rgba(255, 255, 255, 0.06)"};
  box-shadow: ${({ theme }) =>
    theme.body === "#fafbfc"
      ? "0 4px 20px rgba(0, 0, 0, 0.06)"
      : "0 4px 20px rgba(0, 0, 0, 0.25)"};
  z-index: 1000;
  transition: all 0.3s ease;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

export const CenterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8em;

  .separator {
    font-size: 0.75em;
    opacity: 0.5;
    font-weight: 500;
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2em;
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.4em 1em 0.4em 0.8em;
  background: ${({ theme }) => theme.primary};
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.78em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    font-size: 0.95em;
  }

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const DateDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.3em 0.6em;
  background: ${({ theme }) =>
    theme.body === "#fafbfc"
      ? "rgba(0, 0, 0, 0.04)"
      : "rgba(255, 255, 255, 0.05)"};
  border-radius: 12px;
  border: 1px solid
    ${({ theme }) =>
      theme.body === "#fafbfc"
        ? "rgba(0, 0, 0, 0.06)"
        : "rgba(255, 255, 255, 0.06)"};

  svg {
    font-size: 0.85em;
    opacity: 0.6;
    color: ${({ theme }) => theme.primary};
  }

  span {
    font-size: 0.78em;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
    opacity: 0.8;
  }
`;

export const CompanyStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.3em 0.8em;
  background: ${({ theme }) =>
    theme.body === "#fafbfc"
      ? "rgba(16, 185, 129, 0.1)"
      : "rgba(16, 185, 129, 0.15)"};
  border-radius: 6px;
  border: 1px solid rgba(16, 185, 129, 0.3);
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    font-size: 0.9em;
    color: ${({ theme }) => theme.primary};
    transition: all 0.2s ease;
  }

  span {
    font-size: 0.78em;
    font-weight: 600;
    color: ${({ theme }) => theme.primary};
    white-space: nowrap;
  }

  &:hover {
    background: ${({ theme }) =>
      theme.body === "#fafbfc"
        ? "rgba(16, 185, 129, 0.15)"
        : "rgba(16, 185, 129, 0.2)"};
    border-color: rgba(16, 185, 129, 0.4);
    transform: translateY(-1px);

    svg {
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(0);
  }
`;

export const StatusItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4em;
  color: ${({ theme }) => theme.text};
  opacity: 0.9;
  font-size: 0.82em;
  transition: all 0.25s ease;
  cursor: default;

  svg {
    font-size: 0.95em;
    opacity: 1;
    color: ${({ theme }) => theme.primary};
  }

  span {
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  &:hover {
    opacity: 1;

    svg {
      opacity: 1;
      filter: brightness(1.2);
    }
  }
`;

export const SimulationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.3em 0.7em;
  background: ${({ theme }) =>
    theme.body === "#fafbfc"
      ? "rgba(139, 92, 246, 0.1)"
      : "rgba(139, 92, 246, 0.15)"};
  border-radius: 6px;
  border: 1px solid rgba(139, 92, 246, 0.3);
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: 0.3em;
  padding-left: 0.6em;

  svg {
    font-size: 0.85em;
    color: #8b5cf6;
  }

  span {
    font-size: 0.75em;
    font-weight: 600;
    color: #8b5cf6;
    white-space: nowrap;
  }

  &:hover {
    background: ${({ theme }) =>
      theme.body === "#fafbfc"
        ? "rgba(139, 92, 246, 0.18)"
        : "rgba(139, 92, 246, 0.25)"};
    border-color: rgba(139, 92, 246, 0.5);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SimulationIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.25em 0.6em;
  background: rgba(245, 158, 11, 0.12);
  border-radius: 6px;
  border: 1px solid rgba(245, 158, 11, 0.3);
  margin-left: 0.3em;

  > svg {
    font-size: 0.8em;
    color: #f59e0b;
    flex-shrink: 0;
  }

  > span {
    font-size: 0.72em;
    font-weight: 600;
    color: #f59e0b;
    white-space: nowrap;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StopSimButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 0.2em;
  color: #f59e0b;
  opacity: 0.6;
  transition: all 0.15s ease;

  svg {
    font-size: 0.85em;
  }

  &:hover {
    opacity: 1;
    color: #ef4444;
    transform: scale(1.15);
  }
`;

export const TrialBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.25em 0.7em;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  background: ${({ $variant }) =>
    $variant === 'danger' ? 'rgba(239, 68, 68, 0.12)' :
    $variant === 'warning' ? 'rgba(245, 158, 11, 0.12)' :
    $variant === 'expired' ? 'rgba(239, 68, 68, 0.15)' :
    'rgba(99, 102, 241, 0.12)'};
  border: 1px solid ${({ $variant }) =>
    $variant === 'danger' ? 'rgba(239, 68, 68, 0.3)' :
    $variant === 'warning' ? 'rgba(245, 158, 11, 0.3)' :
    $variant === 'expired' ? 'rgba(239, 68, 68, 0.35)' :
    'rgba(99, 102, 241, 0.3)'};

  svg {
    font-size: 0.8em;
    color: ${({ $variant }) =>
      $variant === 'danger' ? '#ef4444' :
      $variant === 'warning' ? '#f59e0b' :
      $variant === 'expired' ? '#ef4444' :
      '#6366f1'};
  }

  span {
    font-size: 0.72em;
    font-weight: 600;
    color: ${({ $variant }) =>
      $variant === 'danger' ? '#ef4444' :
      $variant === 'warning' ? '#f59e0b' :
      $variant === 'expired' ? '#ef4444' :
      '#6366f1'};
  }

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.1);
  }
`;

export const ThemeToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  margin-left: 0.5em;
  padding-left: 0.8em;
  border-left: 1px solid
    ${({ theme }) =>
      theme.body === "#fafbfc"
        ? "rgba(0, 0, 0, 0.1)"
        : "rgba(255, 255, 255, 0.08)"};

  svg {
    font-size: 0.9em;
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }

  .toggle {
    width: 2em;
    height: 0.8em;
    display: flex;
    border-radius: 50px;
    background-color: ${({ $isDark }) =>
      $isDark ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.15)"};
    border: 1px solid
      ${({ $isDark }) =>
        $isDark ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.15)"};
    align-items: center;
    position: relative;
    transition: all 0.2s;
    cursor: pointer;
    justify-content: ${({ $isDark }) => ($isDark ? "flex-end" : "flex-start")};

    .circle {
      width: 0.7em;
      height: 0.7em;
      display: flex;
      border-radius: 100%;
      background-color: ${({ $isDark }) =>
        $isDark ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.25)"};
      border: 1px solid
        ${({ $isDark }) =>
          $isDark ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.1)"};
      cursor: pointer;
      transition: all 0.2s;
    }
  }
`;
